import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import AllOrders from './AllOrders'
import PendingOrders from './PendingOrders'
import Subscriptions from './Subscriptions'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import Breadcrumb from '../common/Breadcrumb'
import WrappedTabs from '../common/WrappedTabs'
import './admin-order-history.scss'

const AdminOrderHistory = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(null)
  const tabs = [
    {
      key: 0,
      slug: 'all-orders',
      title: 'coltene_store.admin_order_history.all-orders',
      content: <AllOrders />,
    },
    {
      key: 1,
      slug: 'pending-orders',
      title: 'coltene_store.admin_order_history.pending-orders',
      content: <PendingOrders />,
    },
    {
      key: 2,
      slug: 'subscriptions',
      title: 'nav.subscriptions',
      content: <Subscriptions />,
    },
  ]

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const contentParam = params.get('content')
    let selectedTab = tabs[0]
    
    if (contentParam) {
      const match = tabs.find((t) => t.slug === contentParam)
      if (match) selectedTab = match
    }
    
    setActiveTab(selectedTab)
    const expectedQuery = `?content=${selectedTab.slug}`
    
    if (location.search !== expectedQuery) {
      history.replace({ search: expectedQuery })
    }
  }, [location.search])
  
  const handleChangeTab = (tabKey) => {
    const tab = tabs.find((t) => t.key === tabKey)
    if (!tab) return
    setActiveTab(tab)
    history.push({ search: `?content=${tab.slug}` })
  }

  return (
    <div className="admin-order-history-wrapper">
      <Breadcrumb path={location.pathname} />
      <DashboardHeader headerText={t('nav.admin_order_history')} />
      <WrappedTabs tabs={tabs.map((tab) => ({ id: tab.key, name: tab.title }))} activeTab={activeTab?.key} changeTab={handleChangeTab} />
      {activeTab?.content}
    </div>
  )
}

export default AdminOrderHistory
